import { render, staticRenderFns } from "./RideTypeList.vue?vue&type=template&id=4c441b83&"
import script from "./RideTypeList.vue?vue&type=script&lang=js&"
export * from "./RideTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports